import React, { useCallback, useMemo } from 'react';
import { Box, FlatTextInput } from '@common-fe/common-fe';

import { LockboxValidationError, lockboxValidationErrorTitle } from '@/modules/employer/components/Lockbox/lockbox.types';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

const LockboxFormNameInput = () => {
  const { editableLockbox, setEditableLockbox, validationErrors } = useLockboxDetailsStore();

  const hasError = useMemo(
    () => validationErrors?.includes(LockboxValidationError.FORM_NAME_REQUIRED),
    [validationErrors]
  );

  const handleChange = useCallback((value: string) => {
    setEditableLockbox({ formName: value });
  }, [setEditableLockbox]);

  return (
    <Box width="250px">
      <FlatTextInput
        testId="lockbox-form-name"
        name="formName"
        value={editableLockbox?.formName || ''}
        onChange={handleChange}
        placeholder="Enter form name"
        ellipsisMode
        onClear={() => handleChange('')}
        isSmall
        isBold
        withClearButton
        errorText={hasError ? lockboxValidationErrorTitle[LockboxValidationError.FORM_NAME_REQUIRED] : undefined}
      />
    </Box>
  );
};

export default LockboxFormNameInput;
